"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var FeDefaultLink = function FeDefaultLink(_ref) {
  var route = _ref.route,
      href = _ref.href,
      className = _ref.className,
      activeClassName = _ref.activeClassName,
      isNavLink = _ref.isNavLink,
      isActive = _ref.isActive,
      children = _ref.children,
      additionalProps = _ref.additionalProps;
  var props = Object.assign({}, additionalProps);

  if (href) {
    return _react.default.createElement("a", _extends({
      href: href,
      className: className
    }, props), children);
  } else if (route && isNavLink) {
    return _react.default.createElement(_reactRouterDom.NavLink, _extends({
      className: className
    }, props, {
      to: route,
      activeClassName: activeClassName
    }), children);
  } else if (route) {
    return _react.default.createElement(_reactRouterDom.Link, _extends({
      className: className
    }, props, {
      to: route
    }), children);
  } else {
    return null;
  }
};

FeDefaultLink.defaultProps = {
  route: null,
  href: null,
  className: null,
  activeClassName: null,
  isActive: false,
  isNavLink: false,
  children: null,
  additionalProps: null
};
FeDefaultLink.propTypes = {
  /** The url (relative or absolute) to visit when clicking the link */
  route: _propTypes.default.string,

  /** The url (absolute) to visit when clicking the link */
  href: _propTypes.default.string,

  /** The string of CSS class names to apply to the link */
  className: _propTypes.default.string,

  /** The string of CSS class names to append to the link if it is active */
  activeClassName: _propTypes.default.string,

  /** Boolean value indicating whether the link is active or not */
  isActive: _propTypes.default.bool,

  /** Set to true for NavLink component */
  isNavLink: _propTypes.default.bool,

  /** The node to render inside the link */
  children: _propTypes.default.node.isRequired,

  /** Additional props to pass on to the anchor */
  additionalProps: _propTypes.default.object
};
var _default = FeDefaultLink;
exports.default = _default;